<style lang="scss">
  @import '../resources/scss/id_publications.scss';
</style>

<script lang="ts">
  import PublicationsSection from '../api/rest/directus-cms/investigation/models/PublicationsSection'
  import RdPublication from '../api/rest/directus-cms/investigation/models/RdPublication'
  import ProjectPublications from '../api/rest/directus-cms/projects/model/ProjectPublications'
  import type ProjectPublicationsSection from '../api/rest/directus-cms/projects/model/ProjectPublicationsSection'
  import ArrowRight from './svgs/ArrowRight.svelte'

  export let section: PublicationsSection | ProjectPublicationsSection
  function getTitle(section: PublicationsSection | ProjectPublicationsSection) {
    if (section instanceof PublicationsSection) {
      return section.title ?? ''
    } else {
      if (
        section &&
        section.translations &&
        section.translations?.length > 0 &&
        section.translations[0]
      ) {
        return section.translations[0].title
      }
    }
  }
</script>

{#if section}
  <div class="container-fluid bg-neutral-a text-white">
    <div class="container-xxl flex-grow-1">
      <div class="row">
        <div class="col-12 text-break">
          <h1>
            {getTitle(section)}
          </h1>
          <ul class="mt-4 list-unstyled d-flex flex-column gap-3">
            {#each section.publications as publication}
              <li class="font-medium">
                <div class="pub-container">
                  <ArrowRight />
                  {#if publication instanceof RdPublication}
                    <a
                      class="ms-2"
                      href={publication && publication.file
                        ? publication.file.fullUrl ?? '#'
                        : '#'}
                      target="_blank"
                      >{publication.name ?? ''}
                    </a>
                  {:else if publication instanceof ProjectPublications}
                    {#if publication.project_publications_id?.translations[0]?.link !== '' && publication.project_publications_id?.translations[0]?.link}
                      <a
                        class="ms-2"
                        href={publication.project_publications_id?.translations[0].link}
                        target="_blank"
                        >{publication.project_publications_id?.translations[0].name ??
                          ''}</a
                      >
                    {:else if publication.project_publications_id?.translations[0]?.file?.fullUrl !== '' && publication.project_publications_id?.translations[0]?.file?.fullUrl}
                      <a
                        class="ms-2"
                        href={publication.project_publications_id?.translations[0]?.file
                          ?.fullUrl}
                        target="_blank"
                        >{publication.project_publications_id?.translations[0]?.name ??
                          ''}</a
                      >
                    {:else}
                      <span class="ms-2" role="button"
                        >{publication.project_publications_id?.translations[0]?.name ??
                          ''}</span
                      >
                    {/if}
                  {/if}
                </div>
              </li>
            {/each}
          </ul>
        </div>
      </div>
    </div>
  </div>
{/if}
